import qs from 'qs'

export async function fetchCalendlyData(uri: string) {
  const query = qs.stringify({
    uri,
  })
  const url = `/utils/calendly?${query}`
  return fetch(url)
    .then((r) => r.json())
    .then((r) => r.resource)
}
